<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event.index)">
        <p-accordionTab header="{{ 'MATRIZIDENTIDAD.LBL_MATRIZIDENTIDAD' | translate}}" [selected]="tabSeleccionado === 'GENERAL'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fMatrizIdentidad" name="nomMatrizIdentidad">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>{{'MATRIZIDENTIDAD.LBL_CANAL' | translate}}:</label>
                  <p-dropdown disableTab  id="idCanal" name="nomSeguro" [options]="lisCanales" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                     formControlName="idCanal"></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCanal.invalid">
                    {{ 'MATRIZIDENTIDAD.LBL_CANAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>{{'MATRIZIDENTIDAD.LBL_TIPOCLIENTE' | translate}}:</label>
                  <p-dropdown disableTab  id="idTipoCliente" name="nomSeguro" [options]="lisTipoCliente"
                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                    formControlName="idTipoCliente"></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idModoAutenticacion.invalid">
                    {{ 'MATRIZIDENTIDAD.LBL_TIPOCLIENTE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>{{'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' | translate}}:</label>
                  <p-dropdown disableTab  id="idModoAutenticacion" name="nomSeguro" [options]="lisModoAutenticacion"
                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"  formControlName="idModoAutenticacion"
                    (onChange)="validarMetodoEspecifico()"></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idModoAutenticacion.invalid">
                    {{ 'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && llaveExiste">
                    {{ 'MATRIZIDENTIDAD.MSG_ERRORLLAVE' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6" *ngIf="esConfronta">
                <div class="col-12 md:col-2 lg:col-2">
                  <p-checkbox label="{{ 'MATRIZIDENTIDAD.LBL_INDICADORMETODOOPCIONAL' | translate}}" binary="true"
                    id="indicadorMetodoOpcional" name="nomindicadorMetodoOpcional" formControlName="indicadorMetodoOpcional"
                    (onChange)="validarCheckOpcional()"></p-checkbox>
                </div>
                <div class="col-12 md:col-10 lg:col-10" *ngIf="f.indicadorMetodoOpcional.value">
                  <div class="div-form">
                    <label>{{'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' | translate}}:</label>
                    <p-dropdown disableTab  id="idModoAutenticacionOpcional" name="nomSeguro" [options]="lisModoAutenticacion"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                      formControlName="idModoAutenticacionOpcional"></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all"
                      *ngIf="submitted && f.idModoAutenticacionOpcional.invalid">
                      {{ 'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-group" *ngIf="esConfronta">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>{{'MATRIZIDENTIDAD.LBL_TIPOCUESTIONARIO' | translate}}:</label>
                  <p-dropdown disableTab  id="idTipoCuestionario" name="nomSeguro" [options]="lisTiposCuestionarios"
                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                    formControlName="idTipoCuestionario"></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoCuestionario.invalid">
                    {{ 'MATRIZIDENTIDAD.LBL_TIPOCUESTIONARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-3 lg:col-3">
                <p-checkbox label="{{ 'MATRIZIDENTIDAD.LBL_VALIDACIONIDENTIDAD' | translate}}" binary="true"
                  id="indicadorValidacionIdentidad" name="nomindicadorValidacionIdentidad"
                  formControlName="indicadorValidacionIdentidad"></p-checkbox>
              </div>
              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <p-checkbox label="{{ 'MATRIZIDENTIDAD.LBL_TOMADATOS' | translate}}" binary="true" id="indicadorTomaDatos"
                    name="nomindicadorTomaDatosr" formControlName="indicadorTomaDatos"></p-checkbox>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && validacionIdentidad">
                    {{ 'MATRIZIDENTIDAD.MSG_ERRORINDICADOR' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorTomaDatos.value">
                <p-checkbox label="{{ 'MATRIZIDENTIDAD.LBL_INDICADOROBLIGATORIO' | translate}}" binary="true"
                  id="indicadorObligatorio" name="indicadorObligatorio" formControlName="indicadorObligatorio"></p-checkbox>
              </div>
              <div class="col-12 md:col-3 lg:col-3">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true" id="indicador" name="nomIndicador"
                  formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{'BTN_ACTUALIZAR' | translate }}" type="submit" pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>

        <!-- TAB Restricciones Perfil por Vinculación -->
        <p-accordionTab header="{{ 'MATRIZIDENTIDAD.LBL_TIPODECUESTIONARIO' | translate }}"
                        [selected]="tabSeleccionado === 'TIPOSCUESTIONARIOS'"
                        [hidden]="!esConfronta">
            <div class="grid" *ngIf="cargandoCuestionario">
              <div class="col-12 md:col-12 lg:col-12 text-center">
                <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
                <span>{{'LBL_CONSULTANDO' | translate }}</span>
              </div>
            </div>
            <form *ngIf="formularioCuestionario && !cargandoCuestionario" [formGroup]="formularioCuestionario" (ngSubmit)="onSubmitCuestionario()" novalidate id="fMatrizIdentidadTipoCuestionario" name="nomMatrizIdentidadTipoCuestionario">
              <div class="grid form-group">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>*{{'MATRIZIDENTIDAD.LBL_CUESTIONARIO' | translate}}:</label>
                    <p-dropdown disableTab  id="idTipoCuestionario" name="nomTipoCuestionario" [options]="lisTiposCuestionarios"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"  formControlName="idTipoCuestionario"></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fC.idTipoCuestionario.invalid">
                      {{ 'MATRIZIDENTIDAD.LBL_CUESTIONARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>*{{'MATRIZIDENTIDAD.LBL_PRODUCTOS' | translate}}:</label>
                    <p-multiSelect id="idsProductos" name="nomProducto" [options]="lisProductos" filter="filter"
                      defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                      selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idsProductos" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionValue="value"
                                   optionLabel="label"></p-multiSelect>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fC.idsProductos.invalid">
                      {{ 'MATRIZIDENTIDAD.LBL_PRODUCTOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 form-footer-buttons text-align-center">
                  <div class="form-group col-12">
                    <div *ngIf="!guardandoCuestionario">
                      <a (click)="cancelar(formularioCuestionario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                      <button icon="fa fa-floppy-o" label="  {{(matrizIdentidadTiposCuestionarios ? 'BTN_ACTUALIZAR': 'BTN_AGREGAR') | translate }}" type="submit" pButton></button>
                    </div>
                    <div *ngIf="guardandoCuestionario">
                      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                      <span>{{'LBL_GUARDANDO' | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="grid" *ngIf="esConfronta">
              <div class="col-12 md:col-12 lg:col-12">
                <p-table [columns]="columnas" #dt
                         [value]="lisTiposCuestionariosHabilitados" selectionMode="single" dataKey="idMatrizIdentidad"
                         [paginator]="true" [rows]="10"  paginatorPosition="bottom" [loading]="cargandoCuestionario">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row">
                      <td>{{row.matrizIdentidadTiposCuestionarios.nombreTipoCuestionario}}</td>
                      <td>{{row.nombresProductos}}</td>
                      <td class="text-center">
                        <div class="btn-group" role="group">
                          <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="editarTipoCuestionario(row)"></button>
                        </div>
                        <div class="btn-group" role="group">
                          <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                                  title="{{'BTN_DESHABILITAR' | translate}}" pButton
                                  (click)="inhabilitarRegistro(row)" ></button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="columns.length">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                      </td>

                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>




<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
